/* Unbroken Vine — testimonials slider.

   The row is a native scroll-snap container, so it already scrolls and swipes
   with no script. This only adds the two arrows and keeps their disabled state
   honest. If it fails, the row is still scrollable by hand. */
(function () {
  'use strict';

  function setup(viewport) {
    var track = viewport.querySelector('.testimonials__grid');
    var prev = viewport.querySelector('.testimonials__arrow--prev');
    var next = viewport.querySelector('.testimonials__arrow--next');
    if (!track || !prev || !next) return;

    function page() {
      /* Scroll by whole cards rather than a fixed pixel amount, so the row
         always lands on a card edge at any column count. */
      var card = track.querySelector('.testimonials__card');
      if (!card) return track.clientWidth;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
      viewport.classList.toggle('testimonials__viewport--static', max <= 1);
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -page(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: page(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      if (update._t) cancelAnimationFrame(update._t);
      update._t = requestAnimationFrame(update);
    });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('.testimonials__viewport').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* The theme editor rebuilds a section on every change. */
  document.addEventListener('shopify:section:load', init);
})();
